import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form, Select } from 'antd';
import PropTypes from "prop-types";
import {
  InputWrapper,
  LabelWrapper,
  WrapLabel,
  SelectOptionWrapper,
  HideArrow,
  GrantAgreementDropdown
} from "../../ContributionType/styles";
import { Rules } from "../Rules/Rules";
import { changeAccountType, checkVGMutualFund,updateContributionStatus, updateErrorMessage } from "../../../actions";


export class DropDownComponent extends React.Component {
    constructor(props) {
        super(props);
        this.onDropdownChange= this.onDropdownChange.bind(this);
    }

    componentDidUpdate(nextProps){
      if((nextProps.value !== this.props.value)){
        let id = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
        let value = {};
        value[id] = this.props.isCleared ? 'Joint' : this.props.value;
        this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
      }  
   }

   componentWillReceiveProps(nextProps){
      if(nextProps.value !== this.props.value && !(nextProps.isCleared !== this.props.isCleared && nextProps.isCleared)){
        let id = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
        let value = {};
        value[id] =  this.props.value === "" ? undefined : this.props.value ;
        this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
      }
      if((this.props.assetHeld === nextProps.showErrorMessage.assetHeld) && nextProps.showErrorMessage.accountType){
            let id = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
            let value = {};
            value[id] =  this.props.value;
            this.props.form.setFieldsValue(value);
          this.props.form.validateFields();
        if((this.props.accountId) === this.props.giftLength){
          if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected)){
            this.props.updateErrorMessages({type: 'accountType'});
          }
        }
    } else if(nextProps.isCleared !== this.props.isCleared && nextProps.isCleared){
      let id = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
      let value = {};
      value[id] =  'Joint';
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
    }
   }

    onDropdownChange = (e) => {
      let name = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
      let setfield={}
      setfield[name]=e;
      this.props.form.setFieldsValue(setfield);
      this.props.form.validateFields();
        this.props.changeAccountType(e === 'Select account type' ? 'Select Account Type' : e);
        if(this.props.updateSelect === "true"){
            this.props.checkVGFund();
        }
        if(this.props.contribTypeStatus === null) this.props.updateContributionStatus();
    }
    
    onDropdownBlur = (e) => {
      let name = 'addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType;
        let setfield={}
        setfield[name]=e;
        this.props.form.setFieldsValue(setfield);
        this.props.form.validateFields();
        if(this.props.contribTypeStatus === null) this.props.updateContributionStatus();
        this.props.checkVGFund();
  }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { Option } = Select;
        let dropDownValues = [];
        if(this.props.assetHeld === "assetHeldatVG"){
            dropDownValues = ["Select account type","Corporation","Private Foundation"]
        }else if(this.props.assetHeld === "checkOrEBT" || this.props.assetHeld === "wire" ){
            dropDownValues = ["Select account type","Individual","Joint","Trust","Corporation","Private Foundation","Other donor-advised fund"]
        }else{
            dropDownValues = ["Select account type","Individual","Joint","Trust","Corporation","Private Foundation"]
        }
        let dropDownValue = (this.props.value) ? (this.props.value === 'Select Account Type' ? 'Select account type' : this.props.value): undefined;
        return (
        <HideArrow>
        <WrapLabel>
          <Form.Item colon={false}
            label={<LabelWrapper>{this.props.label}</LabelWrapper>}
          >
            {getFieldDecorator('addressdropdownDataID' + this.props.accountId + this.props.assetHeld +  this.props.contributionType, {
              rules: ( Rules.donorType ? Rules.donorType.rules : ""),
            })(
              <InputWrapper>
                <div id={"dropdownData" + this.props.accountId +  this.props.assetHeld + this.props.contributionType} className="relative">
                  
                  {
                    
                  <GrantAgreementDropdown
                    id={this.props.id}
                    aria-labelledby={this.props.property}
                    role="list"
                    onChange={e => this.onDropdownChange(e)}
                    onBlur ={e => this.onDropdownBlur(e)}
                    value={dropDownValue} 
                    placeholder={<SelectOptionWrapper> Select account type </SelectOptionWrapper>}
                    getPopupContainer={() => document.getElementById("dropdownData" + this.props.accountId + this.props.assetHeld + this.props.contributionType )}
                  >
                    {dropDownValues.map((dValue, index) => { return (<Option value={dValue} ><SelectOptionWrapper>{dValue}</SelectOptionWrapper></Option>) })}
                  </GrantAgreementDropdown>





                  }
                </div>
              </InputWrapper>
            )}
          </Form.Item>
        </WrapLabel>
      </HideArrow>
        )
    }

}

const WrappedDropDownComponent = Form.create({ name: "select" })(DropDownComponent);

WrappedDropDownComponent.propTypes = {
  value: PropTypes.string,
  isCleared: PropTypes.bool,
  contribTypeStatus: PropTypes.bool,
  showErrorMessage: PropTypes.object,
  isDummyUpdated: PropTypes.bool,
  isSecuritySelected: PropTypes.bool,
  changeAccountType: PropTypes.func,
    checkVGFund: PropTypes.func,
    updateContributionStatus: PropTypes.func,
    updateErrorMessages: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
    return {
        value: state.getIn(["makeAContribution", "contributionTypes", `${ownProps.assetHeld}`, `${ownProps.contributionType}`,`${ownProps.accountId}`, "type"]),
        isCleared: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'isCleared']),
        contribTypeStatus: state.getIn(['makeAContribution','contributionStatus', 'data', `${ownProps.assetHeld}`]),
        showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
        isDummyUpdated: state.getIn(["makeAContribution", "contributionTypes", "dummyUpdate"]),
        isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
}}

export const mapDispatchToProps = (dispatch, ownProps) => ({
    changeAccountType: e => dispatch(changeAccountType({value: e, accountId : ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld })),
    checkVGFund: e => dispatch(checkVGMutualFund({value: true,property: ownProps.selected, assetHeld: ownProps.assetHeld})),
    updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
    updateErrorMessages: data => dispatch(updateErrorMessage(data))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedDropDownComponent));
